import { defineStore } from 'pinia'
import { useUrlSearchParams } from '@vueuse/core'
import dayjs from 'dayjs'
import { cloneDeep, isNumber } from 'lodash-unified'
import global from '@/common/global'
import { getStorage } from '@/utils/storage'
import { useStoreGlobal } from './global'
import { isMobileDevice } from '@/utils/util'
import { typeViteEnv } from '@/utils/env'

export const useStorePoint = defineStore('point', () => {
  const globalState = useStoreGlobal()
  const paramsUrls = useUrlSearchParams()
  const objectType = document.querySelector('body').getAttribute('data-objectType')
  const getCommonOptions = () => {
    // 判断移动端

    return {
      environment: typeViteEnv('VITE_USE_MODE'),
      bhv_time: dayjs().unix(),
      r_pt: isMobileDevice() ? 'h5' : 'PC'
    }
  }

  const getLiveInfo = () => {
    const info: any = {}

    try {
      const contentId = document.querySelector('body').getAttribute('data-id')
      const tpid = document.querySelector('body').getAttribute('data-tplId')
      // 寻常直播
      const firstLive: {
        name: string
        recordUrl: string
        pullStreamUrl: string
        id: number
        playPreviewImageFullUrl: string
        // @ts-ignore
      } = vLives?.find((item) => item.liveId == contentId)

      // @ts-ignore
      info.live_stream_type = live.vr ? '2' : '1'
      info.live_mode = tpid == '6' ? '2' : '1'
      info.vlive_id = firstLive.id
      info.vlive_name = firstLive.name
    } catch (e) {}

    return info
  }

  const getPublicDetails = () => {
    const details: BffContentDetails = cloneDeep(
      Object.keys(globalState.details)?.length === 0
        ? getStorage({
            key: 'globalDetails',
            originKey: true,
            encryption: false
          })
        : globalState.details
    )
    const pathnameList = location.pathname?.split('/') || []
    const parentId = pathnameList?.[pathnameList.length - 2]
    const mainParent = parentId
      ? details.channelList?.some((p) => p.channelId == parentId)
        ? details.channelList?.find((p) => p.channelId == parentId) || details.channelList?.[0]
        : details.subjectList?.find((p) => p.topicId == parentId) || details.channelList?.[0]
      : details.channelList?.[0] || {}

    return {
      details,
      mainParent: (mainParent || {}) as unknown as {
        pageId: number | string
        channelId: number | string
      }
    }
  }

  const getRecommondOptions = ({
    type,
    newsId,
    newsType,
    currentTime
  }: {
    type: string
    newsId: any
    newsType: any
    currentTime?: number
  }) => {
    const isRecommd = paramsUrls.recommd === '1'
    const traceId = paramsUrls.traceId
    const sceneId = paramsUrls.sceneId
    const traceInfo = paramsUrls.traceInfo

    let traceOptions = {}

    if (isRecommd) {
      traceOptions = {
        bhv_type: type,
        trace_id: traceId,
        trace_info: traceId === 'selfhold' ? '1' : traceInfo || '1',
        scene_id: sceneId,
        bhv_value: isNumber(currentTime) ? currentTime : '1',
        item_id: `${newsId}${
          newsType == '1'
            ? '_video'
            : newsType == '9'
            ? '_image'
            : newsType == '8'
            ? '_article'
            : newsType == '10'
            ? '_item'
            : newsType == '2'
            ? '_live'
            : newsType == '13'
            ? '_audio'
            : ''
        }`,
        item_type: `${
          newsType == '8'
            ? global.item_type.article
            : newsType == '9'
            ? global.item_type.image
            : newsType == '10'
            ? global.item_type.item
            : newsType == '1'
            ? global.item_type.video
            : newsType == '2'
            ? global.item_type.live
            : newsType == '13'
            ? global.item_type.audio
            : ''
        }`
      }
    }

    return traceOptions
  }

  const contentExposure = (type) => {
    const commonDetails = getPublicDetails()

    try {
      window.sensors.track('ContentExposure', {
        page_name:
          commonDetails.details.newsType == '8'
            ? global.page_name.article_detail_page
            : commonDetails.details.newsType == '9'
            ? global.page_name.atlas_detail_page
            : commonDetails.details.newsType == '10'
            ? global.page_name.operation_page
            : commonDetails.details.newsType == '1'
            ? global.page_name.video_detail_page
            : commonDetails.details.newsType == '2'
            ? global.page_name.live_detail_page
            : commonDetails.details.newsType == '13'
            ? global.page_name.audio_detail_page
            : '',
        page_id: commonDetails.mainParent.pageId,
        content_id: commonDetails.details.newsId,
        content_style: commonDetails.details.appstyle,
        content_name: commonDetails.details.newsTitle,
        content_type: type,
        author_name: commonDetails.details.authorList?.map((item) => item.authorName)?.join() || '',
        content_show_channel_id: commonDetails.details.channelList?.[0]?.channelId || '',
        level2channel_id: commonDetails.details.channelList?.[1]?.channelId || '',
        ...getRecommondOptions({
          type: 'expose',
          newsId: commonDetails.details.newsId,
          newsType: type
        }),
        ...getLiveInfo(),
        ...getCommonOptions()
      })
    } catch (e) {
      console.log(e)
    }
  }

  const channelExposure = (type) => {
    const commonDetails = getPublicDetails()

    try {
      window.sensors.track('ChannelExposure', {
        page_name:
          commonDetails.details.newsType == '8'
            ? global.page_name.article_detail_page
            : commonDetails.details.newsType == '9'
            ? global.page_name.atlas_detail_page
            : commonDetails.details.newsType == '10'
            ? global.page_name.operation_page
            : commonDetails.details.newsType == '1'
            ? global.page_name.video_detail_page
            : commonDetails.details.newsType == '2'
            ? global.page_name.live_detail_page
            : commonDetails.details.newsType == '13'
            ? global.page_name.audio_detail_page
            : '',
        page_id: commonDetails.mainParent.pageId,
        content_id: commonDetails.details.newsId,
        content_style: commonDetails.details.appstyle,
        content_name: commonDetails.details.newsTitle,
        content_type: type,
        author_name: commonDetails.details.authorList.map((item) => item.authorName).join(),
        content_show_channel_id: commonDetails.details.channelList?.[0]?.channelId || '',
        level2channel_id: commonDetails.details.channelList?.[1]?.channelId || '',
        email: paramsUrls.email === '1' ? '1' : '0',
        ...getLiveInfo(),
        ...getCommonOptions()
      })
    } catch (e) {}
  }

  const videoPlay = ({ duration }) => {
    const commonDetails = getPublicDetails()

    try {
      window.sensors.track('video_positive_pybk', {
        time_consuming: duration,
        page_name:
          commonDetails.details.newsType == '8'
            ? global.page_name.article_detail_page
            : commonDetails.details.newsType == '9'
            ? global.page_name.atlas_detail_page
            : commonDetails.details.newsType == '10'
            ? global.page_name.operation_page
            : commonDetails.details.newsType == '1'
            ? global.page_name.video_detail_page
            : commonDetails.details.newsType == '2'
            ? global.page_name.live_detail_page
            : commonDetails.details.newsType == '13'
            ? global.page_name.audio_detail_page
            : '',
        page_id: commonDetails.mainParent.pageId,
        content_id: commonDetails.details.newsId,
        content_style: commonDetails.details.appstyle,
        content_name: commonDetails.details.newsTitle,
        content_type: 1,
        author_name: commonDetails.details.authorList.map((item) => item.authorName).join(),
        content_show_channel_id: commonDetails.details.channelList?.[0]?.channelId || '',
        level2channel_id: commonDetails.details.channelList?.[1]?.channelId || '' || '',
        ...getRecommondOptions({
          type: 'click',
          newsId: commonDetails.details.newsId,
          newsType: 1
        }),
        ...getCommonOptions()
      })
    } catch (e) {
      console.log(e)
    }
  }

  const videoEnd = ({ duration, currentTime }) => {
    const commonDetails = getPublicDetails()

    if (objectType == '1') {
      try {
        window.sensors.track('video_end_pybk', {
          duration: duration,
          complet_rate: currentTime > 0 ? (duration == currentTime ? 1 : 0) : 0,
          page_name:
            commonDetails.details.newsType == '8'
              ? global.page_name.article_detail_page
              : commonDetails.details.newsType == '9'
              ? global.page_name.atlas_detail_page
              : commonDetails.details.newsType == '10'
              ? global.page_name.operation_page
              : commonDetails.details.newsType == '1'
              ? global.page_name.video_detail_page
              : commonDetails.details.newsType == '2'
              ? global.page_name.live_detail_page
              : commonDetails.details.newsType == '13'
              ? global.page_name.audio_detail_page
              : '',
          page_id: commonDetails.mainParent.pageId,
          content_id: commonDetails.details.newsId,
          content_style: commonDetails.details.appstyle,
          content_name: commonDetails.details.newsTitle,
          content_type: 1,
          author_name: commonDetails.details.authorList.map((item) => item.authorName).join(),
          content_show_channel_id: commonDetails.details.channelList?.[0]?.channelId || '',
          level2channel_id: commonDetails.details.channelList?.[1]?.channelId || '',
          ...getRecommondOptions({
            type: 'stay',
            newsId: commonDetails.details.newsId,
            newsType: objectType,
            currentTime
          }),
          ...getCommonOptions()
        })
      } catch (e) {}
    }
  }

  const videoError = (err) => {
    const commonDetails = getPublicDetails()

    try {
      window.sensors.track('pybk_error', {
        error_information: err,
        page_name:
          commonDetails.details.newsType == '8'
            ? global.page_name.article_detail_page
            : commonDetails.details.newsType == '9'
            ? global.page_name.atlas_detail_page
            : commonDetails.details.newsType == '10'
            ? global.page_name.operation_page
            : commonDetails.details.newsType == '1'
            ? global.page_name.video_detail_page
            : commonDetails.details.newsType == '2'
            ? global.page_name.live_detail_page
            : commonDetails.details.newsType == '13'
            ? global.page_name.audio_detail_page
            : '',
        page_id: commonDetails.mainParent.pageId,
        content_id: commonDetails.details.newsId,
        content_style: commonDetails.details.appstyle,
        content_name: commonDetails.details.newsTitle,
        content_type: 1,
        author_name: commonDetails.details.authorList.map((item) => item.authorName).join(),
        content_show_channel_id: commonDetails.details.channelList?.[0]?.channelId || '',
        ...getRecommondOptions({
          type: 'click',
          newsId: commonDetails.details.newsId,
          newsType: 1
        }),
        ...getCommonOptions()
      })
    } catch (e) {}
  }

  const nameClick = (type) => {
    const commonDetails = getPublicDetails()

    try {
      window.sensors.track('NameClick', {
        click_name: type,
        page_name:
          commonDetails.details.newsType == '8'
            ? global.page_name.article_detail_page
            : commonDetails.details.newsType == '9'
            ? global.page_name.atlas_detail_page
            : commonDetails.details.newsType == '10'
            ? global.page_name.operation_page
            : commonDetails.details.newsType == '1'
            ? global.page_name.video_detail_page
            : commonDetails.details.newsType == '2'
            ? global.page_name.live_detail_page
            : commonDetails.details.newsType == '13'
            ? global.page_name.audio_detail_page
            : '',
        page_id: commonDetails.mainParent.pageId,
        ...getCommonOptions()
      })
    } catch (e) {}
  }

  const audioClick = () => {
    const commonDetails = getPublicDetails()

    try {
      window.sensors.track('voice_broadcast_click', {
        page_name:
          commonDetails.details.newsType == '8'
            ? global.page_name.article_detail_page
            : commonDetails.details.newsType == '9'
            ? global.page_name.atlas_detail_page
            : commonDetails.details.newsType == '10'
            ? global.page_name.operation_page
            : commonDetails.details.newsType == '1'
            ? global.page_name.video_detail_page
            : commonDetails.details.newsType == '2'
            ? global.page_name.live_detail_page
            : commonDetails.details.newsType == '13'
            ? global.page_name.audio_detail_page
            : '',
        page_id: commonDetails.mainParent.pageId,
        content_id: commonDetails.details.newsId,
        content_name: commonDetails.details.newsTitle,
        content_type: 8,
        ...getCommonOptions()
      })
    } catch (e) {}
  }

  const audioPlay = ({ duration }) => {
    try {
      const commonDetails = getPublicDetails()

      window.sensors.track('audio_positive_pybk', {
        time_consuming: duration,
        page_name:
          commonDetails.details.newsType == '8'
            ? global.page_name.article_detail_page
            : commonDetails.details.newsType == '9'
            ? global.page_name.atlas_detail_page
            : commonDetails.details.newsType == '10'
            ? global.page_name.operation_page
            : commonDetails.details.newsType == '1'
            ? global.page_name.video_detail_page
            : commonDetails.details.newsType == '2'
            ? global.page_name.live_detail_page
            : commonDetails.details.newsType == '13'
            ? global.page_name.audio_detail_page
            : '',
        page_id: commonDetails.mainParent.pageId,
        content_id: commonDetails.details.newsId,
        content_style: commonDetails.details.appstyle,
        content_name: commonDetails.details.newsTitle,
        content_type: 8,
        author_name: commonDetails.details.authorList.map((item) => item.authorName).join(),
        content_show_channel_id: commonDetails.details.channelList?.[0]?.channelId || '',
        level2channel_id: commonDetails.details.channelList?.[1]?.channelId || '',
        ...getRecommondOptions({
          type: 'click',
          newsId: commonDetails.details.newsId,
          newsType: 8
        }),
        ...getCommonOptions()
      })
    } catch (e) {}
  }

  const audioEnd = ({ duration, currentTime }) => {
    try {
      const commonDetails = getPublicDetails()

      window.sensors.track('audio_end_pybk', {
        duration: duration,
        complet_rate: duration == currentTime ? 1 : 0,
        page_name:
          commonDetails.details.newsType == '8'
            ? global.page_name.article_detail_page
            : commonDetails.details.newsType == '9'
            ? global.page_name.atlas_detail_page
            : commonDetails.details.newsType == '10'
            ? global.page_name.operation_page
            : commonDetails.details.newsType == '1'
            ? global.page_name.video_detail_page
            : commonDetails.details.newsType == '2'
            ? global.page_name.live_detail_page
            : commonDetails.details.newsType == '13'
            ? global.page_name.audio_detail_page
            : '',
        page_id: commonDetails.mainParent.pageId,
        content_id: commonDetails.details.newsId,
        content_style: commonDetails.details.appstyle,
        content_name: commonDetails.details.newsTitle,
        content_type: 8,
        author_name: commonDetails.details.authorList.map((item) => item.authorName).join(),
        content_show_channel_id: commonDetails.details.channelList?.[0]?.channelId || '',
        level2channel_id: commonDetails.details.channelList?.[1]?.channelId || '',
        ...getRecommondOptions({
          type: 'stay',
          newsId: commonDetails.details.newsId,
          newsType: 8,
          currentTime
        }),
        ...getCommonOptions()
      })
    } catch (e) {}
  }

  const audioError = (err) => {
    try {
      const commonDetails = getPublicDetails()

      window.sensors.track('audio_error', {
        error_information: err,
        page_name:
          commonDetails.details.newsType == '8'
            ? global.page_name.article_detail_page
            : commonDetails.details.newsType == '9'
            ? global.page_name.atlas_detail_page
            : commonDetails.details.newsType == '10'
            ? global.page_name.operation_page
            : commonDetails.details.newsType == '1'
            ? global.page_name.video_detail_page
            : commonDetails.details.newsType == '2'
            ? global.page_name.live_detail_page
            : commonDetails.details.newsType == '13'
            ? global.page_name.audio_detail_page
            : '',
        page_id: commonDetails.mainParent.pageId,
        content_id: commonDetails.details.newsId,
        content_style: commonDetails.details.appstyle,
        content_name: commonDetails.details.newsTitle,
        content_type: 8,
        author_name: commonDetails.details.authorList.map((item) => item.authorName).join(),
        content_show_channel_id: commonDetails.details.channelList?.[0]?.channelId || '',
        level2channel_id: commonDetails.details.channelList?.[1]?.channelId || '',
        ...getRecommondOptions({
          type: 'click',
          newsId: commonDetails.details.newsId,
          newsType: 8
        }),
        ...getCommonOptions()
      })
    } catch (e) {}
  }

  const contentClick = ({
    pageId,
    newsType,
    newsId,
    appstyle,
    newsTitle,
    author_name,
    link_url,
    live_type,
    live_mode,
    vlive_name,
    vlive_id,
    live_stream_type,
    summary_type,
    summary_id,
    channelId,
    secondId,
    trace = true,
    sceneId,
    traceId,
    traceInfo
  }) => {
    try {
      const trace_id = traceId || 'selfhold'
      const traceOptions = trace
        ? {
            bhv_type: 'click',
            trace_id: trace_id,
            trace_info: trace_id === 'selfhold' ? '1' : traceInfo || '1',
            scene_id: sceneId,
            bhv_value: '1',
            item_id: `${newsId}${
              newsType == '1'
                ? '_video'
                : newsType == '9'
                ? '_image'
                : newsType == '8'
                ? '_article'
                : newsType == '10'
                ? '_item'
                : newsType == '2'
                ? '_live'
                : newsType == '13'
                ? '_audio'
                : ''
            }`,
            item_type: `${
              newsType == '8'
                ? global.item_type.article
                : newsType == '9'
                ? global.item_type.image
                : newsType == '10'
                ? global.item_type.item
                : newsType == '1'
                ? global.item_type.video
                : newsType == '2'
                ? global.item_type.live
                : newsType == '13'
                ? global.item_type.audio
                : ''
            }`
          }
        : {}
      window.sensors.track('ContentClick', {
        page_name:
          newsType == '8'
            ? global.page_name.article_detail_page
            : newsType == '9'
            ? global.page_name.atlas_detail_page
            : newsType == '10'
            ? global.page_name.operation_page
            : newsType == '1'
            ? global.page_name.video_detail_page
            : newsType == '2'
            ? global.page_name.live_detail_page
            : newsType == '13'
            ? global.page_name.audio_detail_page
            : '',
        page_id: pageId,
        content_id: newsId,
        content_style: appstyle,
        content_name: newsTitle,
        content_type: Number(newsType),
        link_url,
        live_type,
        vlive_id,
        vlive_name,
        live_stream_type,
        live_mode,
        author_name,
        summary_type,
        summary_id,
        content_show_channel_id: channelId,
        level2channel_id: secondId,
        ...traceOptions,
        ...getCommonOptions()
      })
    } catch (e) {}
  }

  const contentListExposure = ({
    pageId,
    newsType,
    newsId,
    appstyle,
    newsTitle,
    author_name,
    link_url,
    live_type,
    live_mode,
    vlive_name,
    vlive_id,
    live_stream_type,
    summary_type,
    summary_id,
    channelId,
    secondId,
    trace = true,
    sceneId,
    traceId,
    traceInfo
  }) => {
    try {
      const trace_id = traceId || 'selfhold'
      const traceOptions = trace
        ? {
            bhv_type: 'expose',
            trace_id: trace_id,
            trace_info: trace_id === 'selfhold' ? '1' : traceInfo || '1',
            scene_id: sceneId,
            bhv_value: '1',
            item_id: `${newsId}${
              newsType == '1'
                ? '_video'
                : newsType == '9'
                ? '_image'
                : newsType == '8'
                ? '_article'
                : newsType == '10'
                ? '_item'
                : newsType == '2'
                ? '_live'
                : newsType == '13'
                ? '_audio'
                : ''
            }`,
            item_type: `${
              newsType == '8'
                ? global.item_type.article
                : newsType == '9'
                ? global.item_type.image
                : newsType == '10'
                ? global.item_type.item
                : newsType == '1'
                ? global.item_type.video
                : newsType == '2'
                ? global.item_type.live
                : newsType == '13'
                ? global.item_type.audio
                : ''
            }`
          }
        : {}
      // @ts-ignore
      window.sensors.track('ContentExposure', {
        page_name:
          newsType == '8'
            ? global.page_name.article_detail_page
            : newsType == '9'
            ? global.page_name.atlas_detail_page
            : newsType == '10'
            ? global.page_name.operation_page
            : newsType == '1'
            ? global.page_name.video_detail_page
            : newsType == '2'
            ? global.page_name.live_detail_page
            : newsType == '13'
            ? global.page_name.audio_detail_page
            : '',
        page_id: pageId,
        content_id: newsId,
        content_style: appstyle,
        content_name: newsTitle,
        content_type: Number(newsType),
        link_url,
        live_type,
        vlive_id,
        vlive_name,
        live_stream_type,
        live_mode,
        author_name,
        summary_type,
        summary_id,
        content_show_channel_id: channelId,
        level2channel_id: secondId,
        ...traceOptions,
        ...getCommonOptions()
      })
    } catch (e) {}
  }

  const shareClick = (type: string, objectType) => {
    try {
      const commonDetails = getPublicDetails()

      window.sensors.track('share_type_click', {
        share_type: type,
        page_name:
          commonDetails.details.newsType == '8'
            ? global.page_name.article_detail_page
            : commonDetails.details.newsType == '9'
            ? global.page_name.atlas_detail_page
            : commonDetails.details.newsType == '10'
            ? global.page_name.operation_page
            : commonDetails.details.newsType == '1'
            ? global.page_name.video_detail_page
            : commonDetails.details.newsType == '2'
            ? global.page_name.live_detail_page
            : commonDetails.details.newsType == '13'
            ? global.page_name.audio_detail_page
            : '',
        page_id: commonDetails.mainParent.pageId,
        content_id: commonDetails.details.newsId,
        content_style: commonDetails.details.appstyle,
        content_name: commonDetails.details.newsTitle,
        content_type: objectType,
        author_name: commonDetails.details.authorList.map((item) => item.authorName).join(),
        content_show_channel_id: commonDetails.details.channelList?.[0]?.channelId || '',
        level2channel_id: commonDetails.details.channelList?.[1]?.channelId || '',
        ...getRecommondOptions({
          type: 'share',
          newsId: commonDetails.details.newsId,
          newsType: commonDetails.details.newsType
        }),
        ...getLiveInfo(),
        ...getCommonOptions()
      })
    } catch (e) {
      console.log(e)
    }
  }

  return {
    getRecommondOptions,
    getCommonOptions,
    getPublicDetails,
    contentListExposure,
    audioPlay,
    audioEnd,
    audioError,
    audioClick,
    shareClick,
    contentClick,
    nameClick,
    videoPlay,
    videoEnd,
    videoError,
    channelExposure,
    contentExposure
  }
})
